/* 🤖 this file was generated by svg-to-ts */
export const matIconDeveloperMode: {
  name: 'developer-mode';
  data: string;
} = {
  name: 'developer-mode',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M7 5h10v2h2V3c0-1.1-.9-1.99-2-1.99L7 1c-1.1 0-2 .9-2 2v4h2V5zm8.41 11.59L20 12l-4.59-4.59L14 8.83 17.17 12 14 15.17l1.41 1.42zM10 15.17 6.83 12 10 8.83 8.59 7.41 4 12l4.59 4.59L10 15.17zM17 19H7v-2H5v4c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4h-2v2z"/></svg>`
};
